<template>
    <v-container fluid>
        <transition name="fadeonly" mode="out-in">
            <router-view></router-view>
        </transition>
    </v-container>
</template>

<script>
export default {}
</script>
